import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environment/environment';

@Injectable({
  providedIn: 'root'
})
export class GameListService {
  private http = inject(HttpClient);


  getGames(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/game`);
  }
}
